// src/utils/dateUtils.js

// Function to get the current date in YYYY-MM-DD format
export function getCurrentDateInFormat() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  // Function to get the current time in HH:MM format
  export function getCurrentTime() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}`;
  }
  
  // You can add more date utility functions as needed
  export function getCurrentDateTime() {
    return `${getCurrentDateInFormat()} ${getCurrentTime()}`;
}
  
export function changeDateFormate(currentDate) {
  let formattedAppointmentDate = '';

  if (currentDate) {
    // Validate YYYY-MM-DD format (basic check)
    const datePattern = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

    if (datePattern.test(currentDate)) {
      const [year, month, day] = currentDate.split('-');
      formattedAppointmentDate = `${day}-${month}-${year}`;
    } else {
      // Optionally, you can return the original value or empty string
      formattedAppointmentDate = currentDate;
    }
  }

  return formattedAppointmentDate;
};

export function changeTimeFormate(currentTime) {

  if (currentTime) {
    // Check if format matches HH:MM where HH = 00-23, MM = 00-59
    const timePattern = /^([01]?\d|2[0-3]):([0-5]\d)$/;

    const match = currentTime.match(timePattern);

    if (match) {
      let [hours, minutes] = match[0].split(':').map(Number);
      const postfix = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;

      return`${hours}:${minutes.toString().padStart(2, '0')} ${postfix}`;
    } else {
      // If not valid HH:MM, optionally keep as-is or handle differently
      return currentTime;
    }
  }
}
